import React from 'react';
import '../../css/MarqueeText.css';

const MarqueeText = () => {
  const content = "Holistic . Precision . Advanced Research .";

  return (
    <div className="marquee-wrapper">
      <div className="marquee">
        <div className="marquee-content">
          {[...Array(10)].map((_, i) => (
            <span key={i}>{content}</span>
          ))}
        </div>
      </div>
    </div>
  );
};
export default MarqueeText;
